export enum ProposalStatus {
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
}

export enum BidStatus {
  AWAITING = 'AWAITING',
  SUBMITTED = 'SUBMITTED',
  LOST = 'LOST',
  WON = 'WON',
  MISSED = 'MISSED',
}

/**
 * Written by Windsurf using model: Claude Sonnet 4.5 (Thinking)
 * Payment reference methodology:
 * - DEPOSIT: Percentages reference deposit amount, must sum to 100%
 * - BOOK_VALUE: Percentages reference contract book value at payment time, final payment always 100%
 */
export enum ScheduleType {
  DEPOSIT = 'DEPOSIT',
  BOOK_VALUE = 'BOOK_VALUE',
}

export enum PaymentRowType {
  PERCENTAGE = 'PERCENTAGE',
  DOLLAR = 'DOLLAR',
}

export interface IssuerDto {
  issuerTenantId: string
  displayName: string
  enabled: boolean
}

export interface PaymentRow {
  payoutAmount: number
  payoutPercentage: number
  paymentDate: Date | string | null
  inputType?: PaymentRowType
}

export interface Scenario {
  id: string
  proposedRate: number | null
  wamYears: number | null
  paymentSchedule: PaymentRow[]
  bids: Bid[]
  selectedBids: SelectedBid[]
}

export interface Bid {
  id: string
  status: BidStatus | null
  rate: number | null
  treasuryRate: number | null
  notes: string | null
  issuerTenantId: string
  createdAt: string | null
}

export interface ProposalFile {
  id: string
  name: string
}

export interface Proposal {
  id: string
  buyerTenantName: string
  fund?: string
  depositAmount?: number
  depositDate?: string
  bidDeadline?: string
  bidDeadlineTimezone?: string
  scheduleType?: ScheduleType
  description?: string
  scenarios: Scenario[]
  issuerTenantIds: string[]
  files: ProposalFile[]
  documents?: File[] // Local file objects (for UI only, not sent to API)
  status: ProposalStatus
  statusSummary?: string
  createdAt: string
}

export interface IssuerProposalOverviewDto {
  proposalId: string
  buyerTenantName: string
  fund: string
  bidDeadline: string
  depositAmount: number
  depositDate: string
  statusSummary: string
  createdAt: string
}

// API Request and Response Types
/**
 * Written by Windsurf using model: Claude Sonnet 4.5 (Thinking)
 */
export interface CreateProposalDto {
  fund: string
  depositAmount: number
  depositDate: string
  bidDeadline: string
  bidDeadlineTimezone: string
  scheduleType: ScheduleType
  description?: string
  scenarios: Scenario[]
  issuerTenantIds: string[]
  files: ProposalFile[]
}

export interface CreateBidDto {
  scenarioId: string
  rate: number
  treasuryRate: number
  notes: string | null
}

export interface ProposalCreationResponse {
  proposalId: string
}

export interface BidCreationResponse {
  scenarioId: string
  bidId: string
}

export interface FileUploadResponse {
  fileId: string | null
  fileName: string
  success: boolean
  errorMessage?: string
}

export interface FileType {
  mimeType: string
  extensions: string[]
}

export interface PartialMaturity {
  paymentDate: Date | string | null
  amount: number
  inputType: string
}

export interface SelectedBid {
  selectedBidId: string
  issuerTenantId: string
  rate: number
  treasuryRate: number
  amount: number
  wamYears?: number | null
  partialMaturities?: PartialMaturity[]
  createdAt: string
}

export interface BuyerProposalDetailDto {
  proposalId: string
  fund: string
  depositAmount: number
  depositDate: string
  bidDeadline: string
  bidDeadlineTimezone?: string | null
  scheduleType: ScheduleType
  description?: string
  scenarios: Scenario[]
  issuerTenantIds: string[]
  files: ProposalFile[]
  status: ProposalStatus
  createdAt: string
}

export interface BuyerProposalOverviewDto {
  proposalId: string
  fund: string
  depositAmount: number
  depositDate: string
  bidDeadline: string
  bidDeadlineTimezone?: string | null
  status: ProposalStatus
  createdAt: string
  responseSummary: string
}
